<template>
	<div class="faq">
		<div
			v-for="(item, index) in faqs"
			:key="index"
			class="dropdown-faq"
			:class="{ open: activeIndex === index }"
		>
			<button
				type="button"
				class="faq-title"
				:aria-expanded="activeIndex === index ? 'true' : 'false'"
				@click="toggleFaq(index)"
			>
				<span class="faq-q">{{ item.question }}</span>
				<span class="faq-icon" aria-hidden="true">
					<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2">
						<path d="M6 9l6 6 6-6" />
					</svg>
				</span>
			</button>

			<div v-show="activeIndex === index" class="faq-body">
				<p class="content" v-html="item.answer"></p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		faqs: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			activeIndex: null,
		}
	},
	methods: {
		toggleFaq(index) {
			this.activeIndex = this.activeIndex === index ? null : index
		},
	},
}
</script>

<style lang="scss" scoped>
.faq {
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin: 8px 0 20px;
	padding: 0;
}

.dropdown-faq {
	background: #fff;
	border: 1px solid #dce8e5;
	border-radius: 12px;
	overflow: hidden;
	transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

	&.open {
		border-color: #86efac;
		background: #f7fdf9;
		box-shadow: 0 6px 18px rgba(22, 163, 74, 0.08);
	}
}

.faq-title {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 14px;
	width: 100%;
	margin: 0;
	padding: 16px 18px;
	border: 0;
	background: transparent;
	cursor: pointer;
	text-align: left;
	font: inherit;
	color: #0f172a;
}

.faq-q {
	flex: 1;
	font-size: 16px;
	font-weight: 700;
	line-height: 1.45;
}

.faq-icon {
	flex-shrink: 0;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	border-radius: 999px;
	background: #eaf7f3;
	color: #15803d;
	transition: transform 0.25s ease, background 0.2s ease, color 0.2s ease;
}

.dropdown-faq.open .faq-icon {
	transform: rotate(180deg);
	background: #22c55e;
	color: #fff;
}

.faq-body {
	padding: 0 18px 16px;
}

.content {
	margin: 0;
	padding: 0;
	font-size: 16px;
	line-height: 1.75;
	color: #64748b;
}

/* 覆盖全局 p 内边距，避免 FAQ 答案撑开 */
.faq ::v-deep .content,
.faq ::v-deep p {
	margin: 0;
	padding: 0;
	font-size: 16px;
	line-height: 1.75;
	color: #64748b;
}
</style>
